var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlFilledFourteen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4671_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0069 32.1625H23.1007C22.7301 32.1625 22.4297 31.862 22.4297 31.4914V26.4602C22.4297 25.2449 21.441 24.2562 20.2257 24.2562C19.0104 24.2562 18.0217 25.2449 18.0217 26.4602V31.4914C18.0217 31.862 17.7213 32.1625 17.3507 32.1625H9.44447C9.07388 32.1625 8.77344 31.862 8.77344 31.4914V20.7102C8.77344 20.5322 8.84416 20.3615 8.97 20.2357L19.7512 9.45451C20.0133 9.19249 20.4381 9.19249 20.7002 9.45451L31.4814 20.2357C31.6072 20.3615 31.678 20.5322 31.678 20.7102V31.4914C31.678 31.862 31.3775 32.1625 31.0069 32.1625Z",
    fill: "#2D5E59"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5499 14.6172C37.1772 15.7802 36.2567 16.7007 35.0938 17.0733C36.2567 17.446 37.1772 18.3665 37.5499 19.5295C37.9226 18.3665 38.8427 17.446 40.0057 17.0733C38.8427 16.7007 37.9226 15.7805 37.5499 14.6172Z",
    fill: "#2D5E59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3415 0C29.7516 3.28248 27.157 5.87735 23.875 6.46749C27.157 7.05737 29.7516 9.65249 30.3415 12.9347C30.9314 9.65224 33.526 7.05737 36.808 6.46749C33.526 5.87735 30.9314 3.28248 30.3415 0Z",
    fill: "#2D5E59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40596 21.9297C3.0037 23.6089 1.67924 24.9336 0 25.3359C1.67924 25.7382 3.00395 27.0629 3.40596 28.7421C3.80822 27.0629 5.13268 25.7382 6.81192 25.3359C5.13268 24.9336 3.80822 23.6089 3.40596 21.9297Z",
    fill: "#2D5E59"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4671_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9045,
    height: 22.9045,
    fill: "white",
    transform: "translate(8.77344 9.25781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlFilledFourteen);
export default __webpack_public_path__ + "static/media/al-filled-fourteen.b59dc69afbe811731803564375e00f6a.svg";
export { ForwardRef as ReactComponent };